function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.7rem",
    height: "1.7rem",
    viewBox: "0 0 24 24",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 21a13.21 13.21 0 0 1-4.34-1.91l1.82-2.61a2 2 0 0 1 2.68-.51c.33.21.67.4 1 .59a2 2 0 0 1 .84 2.82l-.62.95A1.17 1.17 0 0 1 15 21ZM3.67 7.67l1-.62a2 2 0 0 1 2.85.73c.19.36.38.7.59 1a2 2 0 0 1-.51 2.68l-2.66 1.85A13.21 13.21 0 0 1 3 9a1.17 1.17 0 0 1 .67-1.33Z",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7a5 5 0 0 1 5 5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "primary",
    d: "M11 3.06A8.26 8.26 0 0 1 12 3a9 9 0 0 1 9 9 8.26 8.26 0 0 1-.06 1M15 21a13.21 13.21 0 0 1-4.34-1.91l1.82-2.61a2 2 0 0 1 2.68-.51c.33.21.67.4 1 .59a2 2 0 0 1 .84 2.82l-.62.95A1.17 1.17 0 0 1 15 21ZM3.67 7.67l1-.62a2 2 0 0 1 2.85.73c.19.36.38.7.59 1a2 2 0 0 1-.51 2.68l-2.66 1.85A13.21 13.21 0 0 1 3 9a1.17 1.17 0 0 1 .67-1.33Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "primary",
    d: "M4.94 13.31a17.72 17.72 0 0 0 2.58 3.17 17.72 17.72 0 0 0 3.17 2.58",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.832e6916a413735a3d2e89a46b7351a6.svg";
export { ForwardRef as ReactComponent };